export enum DataUnitOPEEnum {
  GetDataUnits = 'getDataUnits',
  DelDataUnit = 'delDataUnit'
}
